<template>
  <div class='ContActions'>
    <slot/>
  </div>
</template>

<script>
export default {
  name: 'ContActions'
}
</script>

<style scoped>
.ContActions {
  display: flex;
  justify-content: left;
  padding: 1%;
  gap: 1%;
  border-bottom: thin solid #CCCCCC;
}
</style>
